import { AuthLogin } from './AuthLogin'

export default AuthLogin
